module.exports = __webpack_public_path__ + "static/img/itemBtnBg2.02abfa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/itemBtnBg2.png
// module id = Q6sM
// module chunks = 0